var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"text-xs-center"},[_c('h1',[_vm._v("Seite nicht gefunden (404)")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }